export default __webpack_public_path__ + "assets/spaceExpo.87e277b9.png";